export const COLLECTION = {
  templetes: "templetes",
  styles:"styles"
};

export const ACTIONS = {
  PAGE_NAVIGATION : "PAGE_NAVIGATION",
  OPEN_MAIL : "OPEN_MAIL"
}

export const ORG_ID=["WQ1JmCr2uHOe0n5Nu5Kh","RXwsv9STojMNdz2LzKMm","VGMHRRorj7N1u7c13F9W"]



export const PAGETYPE = {
  home_page: "homePage",
  interview: "interview",
  upcycle: "upcycle",
  warranty: "warrantyInfo",
  resale:"resale",
  repair:"repair",
  return:"return",
  recycle:'recycle',
  care:"care",
  supply_chain:"supply_chain",
  fabric_information:"fabric_information",
  yourOutfits: "yourOutfits",
};

export const STYLES = {
  acqua: "acqua",
  amarezza: "amarezza",
};

export const EVENTS = {
  HOME_PAGE:"home_page",
  RETURN:"return",
  CARE:"care",
  UPCYCLE:"upcycle",
  RECYCLE:'recycle',
  REPAIR:"repair",
  RESALE:"resale",
  SUPPLY_CHAIN:"supply_chain",
  FABRIC_INFORMATION:"fabric_information",
  HELP_AND_CONTACT:"help_and_contact",
  LEARN_MORE:"learn_more",
  CREATE_RETURN:"create_return",
  UPCYCLE_SELECTED:"upcycle_selected",
  MAKE_APPOINTMENT:"make_appointment",
  CONTINUE:"continue"
}

export const DESKTOPSIZE = 768;


